import type { Category, Vehicle, VehicleSegment } from '../types/catalog'

export const dealership = {
  name: 'Porsche North Miami',
  address: '15055 Biscayne Blvd, North Miami, FL 33181',
  phoneLabel: '(305) 705-2200',
  phoneHref: 'tel:+13057052200',
  hours: [
    { days: 'Ventas · Lun – Vie', time: '9:00 AM – 7:00 PM' },
    { days: 'Ventas · Sábado', time: '9:00 AM – 6:00 PM' },
    { days: 'Servicio · Lun – Vie', time: '7:30 AM – 6:00 PM' },
    { days: 'Domingo', time: 'Cerrado' },
  ],
}

/** Asesora de ventas asignada a los leads del sitio. */
export const advisor = {
  name: 'María Rodríguez',
  role: 'Asesora de Ventas Certificada Porsche',
  tagline:
    'Más de 10 años acompañando a clientes del sur de la Florida en la compra, leasing y trade-in de su Porsche.',
  phoneLabel: '+1 (728) 777-4108',
  phoneHref: 'tel:+17287774108',
  whatsappHref: 'https://wa.me/17287774108',
  email: 'mario@porshesales.com',
  emailHref: 'mailto:mario@porshesales.com',
  photo:
    'https://cdn.magicpatterns.com/patterns/generated-images/0fa54d37-3038-4714-96c1-b303e06eed26.jpg',
  responseTime: 'Respuesta promedio en menos de 15 minutos',
}

export const leadInterests = [
  'Porsche 911 Carrera',
  'Porsche Taycan',
  'Porsche Cayenne',
  'Porsche Macan',
  'Porsche Panamera',
  'Pre-Owned Certificado',
  'Servicio y Partes',
]

export const leadTimelines = ['Lo antes posible', 'En 30 días', 'En 1 a 3 meses', 'Solo explorando']

export const navLinks = [
  { label: 'Vehículos Nuevos', href: '#inventario' },
  { label: 'Pre-Owned', href: '#categorias' },
  { label: 'Servicio y Partes', href: '#servicio' },
  { label: 'Financiamiento', href: '#financiamiento' },
  { label: 'Contacto', href: '#contacto' },
]

export const categories: Category[] = [
  {
    id: 'nuevos',
    title: 'Vehículos Nuevos',
    meta: '84 disponibles',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/23a59b82-ddc0-4c3d-bfbf-82f3dd1e9643.jpg',
  },
  {
    id: 'pre-owned',
    title: 'Pre-Owned Certificados',
    meta: '46 disponibles',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/332675e5-85f8-4855-b7b9-db0106972f80.jpg',
  },
  {
    id: 'servicio',
    title: 'Servicio y Partes',
    meta: 'Técnicos certificados',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f5dbfca1-c79d-4844-83a8-b55a15144273.jpg',
  },
  {
    id: 'tequipment',
    title: 'Accesorios Tequipment',
    meta: 'Originales de fábrica',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8fe1ea00-1c2c-40bd-a408-52f16911cb14.jpg',
  },
]

export const vehicles: Vehicle[] = [
  {
    id: '911-carrera',
    model: '911 Carrera',
    trim: 'Coupé · 379 hp · PDK 8 vel.',
    paint: 'Guards Red',
    paintHex: '#d5001c',
    segment: 'Deportivos',
    basePrice: 122095,
    leaseFrom: 1699,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c0bd6b1e-f97f-4f16-9ece-5666330d9946.jpg',
    badge: 'New Arrival',
  },
  {
    id: 'taycan',
    model: 'Taycan',
    trim: '100% eléctrico · Carga rápida 800V',
    paint: 'Gentian Blue',
    paintHex: '#1b4f9c',
    segment: 'Eléctricos',
    basePrice: 99400,
    leaseFrom: 1249,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ccbcadd7-7921-409e-9795-b3618e648f81.jpg',
    badge: 'Electric',
  },
  {
    id: 'cayenne',
    model: 'Cayenne',
    trim: 'SUV · 348 hp · Tracción integral',
    paint: 'Carrara White',
    paintHex: '#eef0f2',
    segment: 'SUV',
    basePrice: 80850,
    leaseFrom: 1099,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5bb46944-0f54-4e65-9000-f4a72afae5cd.jpg',
    badge: 'New Arrival',
  },
  {
    id: 'macan',
    model: 'Macan',
    trim: 'SUV compacto · 261 hp',
    paint: 'Volcano Grey',
    paintHex: '#6b6d70',
    segment: 'SUV',
    basePrice: 63100,
    leaseFrom: 849,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a33d56ed-4f3d-4b7d-a37a-aa159d93208b.jpg',
    badge: 'Oferta',
  },
  {
    id: 'panamera',
    model: 'Panamera',
    trim: 'Sedán deportivo · 348 hp',
    paint: 'Jet Black Metallic',
    paintHex: '#141516',
    segment: 'Sedanes',
    basePrice: 102400,
    leaseFrom: 1399,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/733b14cf-4994-44d1-b6c7-9694b67d2aec.jpg',
  },
  {
    id: '911-certificado',
    model: '911 Carrera S',
    trim: 'Pre-Owned Certificado · 12.400 mi',
    paint: 'GT Silver Metallic',
    paintHex: '#b9bcc0',
    segment: 'Deportivos',
    basePrice: 138900,
    leaseFrom: 1849,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4b25f85d-4f68-4ee0-8d82-660c93015200.jpg',
    badge: 'Certified',
  },
]

export const vehicleFilters: Array<'Todos' | VehicleSegment> = [
  'Todos',
  'Deportivos',
  'SUV',
  'Eléctricos',
  'Sedanes',
]

export const footerColumns = [
  {
    title: 'Ventas',
    links: ['Inventario Nuevo', 'Pre-Owned Certificados', 'Prueba de Manejo', 'Ofertas Especiales'],
  },
  {
    title: 'Postventa',
    links: ['Agendar Servicio', 'Partes Originales', 'Colisión y Pintura', 'Tequipment'],
  },
  {
    title: 'Concesionario',
    links: ['Sobre Nosotros', 'Financiamiento', 'Trade-In', 'Aviso de Privacidad'],
  },
]

export const formatPrice = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value)
